import { api } from "../api";

import { startOfLocalDay } from "@/helpers/date-utils";
import { PaginationOptions, PaginatedResponse } from "@/types/Pagination";

export type PedigreeOrderFilters = {
    dogId: string;
    dogName: string;
    personName: string;
    printType: number;
    createdDateFrom: Temporal.PlainDate | null;
    createdDateTo: Temporal.PlainDate | null;
    printedDateFrom: Temporal.PlainDate | null;
    printedDateTo: Temporal.PlainDate | null;
    printed: boolean | null;
};

export const getPedigreeOrdersList = async (
    options: PaginationOptions,
    filters: PedigreeOrderFilters,
): Promise<PaginatedResponse<object>> => {  
    const { page, itemsPerPage, sortBy, sortDesc } = options;
    const { createdDateFrom, createdDateTo, printedDateFrom, printedDateTo, ...otherFilters } = filters;

    const sort = !!sortBy?.length ? sortBy[0] : 'id';
    const ascending = !!sortDesc?.length ? !sortDesc[0] : true;
    const params = {
        ...otherFilters,
        pageSize: itemsPerPage ?? 10,
        page: (page ?? 1) - 1,
        ascending,
        sort,
        createdAtFrom: createdDateFrom ? startOfLocalDay(createdDateFrom) : undefined,
        createdAtTo: createdDateTo ? startOfLocalDay(createdDateTo.add({ days: 1 })) : undefined,
        printedAtFrom: printedDateFrom ? startOfLocalDay(printedDateFrom) : undefined,
        printedAtTo: printedDateTo ? startOfLocalDay(printedDateTo.add({ days: 1 })) : undefined,
    };

    const { data } = await api.get<PaginatedResponse<object>>('/Admin/pedigrees', { params });

    return data;
};

export const markPedigreeOrdersPrinted = async (orderIds: number[]): Promise<any> => {
    const { data } = await api.post<any>(`/Admin/pedigrees/markPrinted?ids=${orderIds.join('&ids=')}`);

    return data;
};

export const registerPedigreeOrder = async (request: object): Promise<any> => {
    const { data } = await api.post<object>(`/Admin/pedigrees/order`,  request);

    return data;
};

export const getPedigreeFees = async (personId: number): Promise<any> => {
    const { data } = await api.get<any>(`/Admin/pedigrees/fees/${personId}`);
    return data;
};

export default {
    getPedigreeOrdersList,
    markPedigreeOrdersPrinted,
    registerPedigreeOrder,
    getPedigreeFees,
};
